import BaseEntity from '../BaseEntity';
import ContactData from '../basic-types/ContactData';
import Document from '../basic-types/Document';
import Location from '../basic-types/Location';

export default abstract class Company extends BaseEntity {
    public companyName: string;
    public registeredCompanyName: string;
    public contactData: ContactData;
    public location: Location;
    public logo: Document;
    public visible: boolean;
    public visibilityRequested: boolean;
    public freeCancellation: boolean;
    public freeCancellationDays: number;
    public uidNumber?: string;

    public description: Record<string, string>;
    public agb: Record<string, string>;
    public paymentConditions: Record<string, string>;
    public reversalConditions: Record<string, string>;
    public confirmationConclusion: Record<string, string>;

    public registrationTOS: string;
    public registrationTosComparableVersion: number;

    constructor(json: any) {
        super(json);

        this.companyName = json.companyName;
        this.registeredCompanyName = json.registeredCompanyName;
        this.contactData = ContactData.fromJson(json.contactData);
        this.location = json.location;
        this.logo = json.logo;
        this.visible = json.visible;
        this.visibilityRequested = json.visibilityRequested;
        this.freeCancellation = json.freeCancellation;
        this.freeCancellationDays = json.freeCancellationDays;
        this.uidNumber = json.uidNumber;

        this.description = json.description;
        this.agb = json.agb;
        this.paymentConditions = json.paymentConditions;
        this.reversalConditions = json.reversalConditions;
        this.confirmationConclusion = json.confirmationConclusion;
        this.registrationTOS = json.registrationTOS;
        this.registrationTosComparableVersion = json.registrationTosComparableVersion;
    }

    public toString(): string {
        return `${this.companyName} - ${this.registeredCompanyName}`;
    }
}

export enum CompanyOrigin {
    ADMIN_CREATE = 'ADMIN_CREATE',
    ONLINE_REGISTRATION = 'ONLINE_REGISTRATION',
    DAIMLER_IMPORT = 'DAIMLER_IMPORT',
}
